import React, { useState, useLayoutEffect, useRef, useEffect } from "react";
import gsap from "gsap";
import { useLocation } from "wouter";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [location, navigate] = useLocation();

  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <div ref={ref}>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className={`fixed top-8 lg:top-10 lg:right-10 right-6 bg-black bg-opacity-60 rounded-lg lg:h-20 lg:w-20 w-10 h-10 ${
          isOpen && "bg-white !bg-opacity-100"
        } border-[1px] z-20 transition duration-1000`}
      >
        <div className="flex flex-col items-center justify-center gap-[5px] rounded-lg">
          <span
            className={`h-[1px] w-4 lg:w-8 rounded-full bg-white transition ${
              isOpen && "rotate-45 translate-y-2.5 !bg-black"
            }`}
          ></span>
          <span
            className={`h-[1px] w-4 lg:w-8 rounded-full bg-white ${
              isOpen && "scale-x-0 !bg-black"
            } transition`}
          ></span>
          <span
            className={`h-[1px] w-4 lg:w-8 rounded-full bg-white ${
              isOpen && "-rotate-45 -translate-y-2.5 !bg-black"
            } `}
          ></span>
        </div>
      </button>

      {isOpen && (
        <div
          
          className="absolute lg:top-36 top-20 lg:right-10 right-6 z-40"
        >
          <div className="bg-black border-[0.5px] border-white px-8 lg:px-16 py-8 lg:py-12 rounded-md lg:rounded-xl">
            <ul className="flex flex-col gap-8 font-raleway font-thin text-2xl lg:text-4xl">
              {location !== "/" && (
                <a href="/">
                  <li className="hover:underline underline-offset-8 decoration-1">
                    Home
                  </li>
                </a>
              )}
              {/* {location !== "/work" && (
                <a href="/work">
                  <li className="hover:underline underline-offset-8 decoration-1">
                    Work
                  </li>
                </a>
              )}
              {location !== "/work-3d" && (
                <a className="hidden lg:block" href="/work-3d">
                  <li className="hover:underline underline-offset-8 decoration-1">
                    3D Work
                  </li>
                </a>
              )} */}
              {location !== "/skills" && (
                <a href="/skills">
                  <li className="hover:underline underline-offset-8 decoration-1">
                    Skills
                  </li>
                </a>
              )}
               {location !== "/game" && (
                <a href="/game">
                  <li className="hover:underline underline-offset-8 decoration-1">
                    Maze Game
                  </li>
                </a>
              )}
              {/* {location !== "/contact" && (
                <a href="/contact">
                  <li className="hidden hover:underline underline-offset-8 decoration-1">
                    Contact
                  </li>
                </a>
              )} */}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};
